/**
 * Поле meta в БД
 * либо JSON с полями description + теги как в public/index.html (apple-mobile-web-app-title и т.д.).
 */

const JSON_KEYS = {
  description: ['description'],
  appleMobileWebAppTitle: ['appleMobileWebAppTitle', 'apple-mobile-web-app-title'],
  applicationName: ['applicationName', 'application-name'],
  msapplicationTileColor: ['msapplicationTileColor', 'msapplication-TileColor'],
  themeColor: ['themeColor', 'theme-color'],
}

function pick(obj, aliases) {
  if (!obj || typeof obj !== 'object') {
    return undefined
  }
  for (const k of aliases) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && obj[k] != null && String(obj[k]).trim() !== '') {
      return String(obj[k]).trim()
    }
  }
  return undefined
}

/**
 * @param {string} [raw]
 * @returns {{ description: string, appleMobileWebAppTitle?: string, applicationName?: string, msapplicationTileColor?: string, themeColor?: string, isJson: boolean }}
 */
export function parseSeoMetaField(raw) {
  const s = raw == null ? '' : String(raw).trim()
  if (!s) {
    return { description: '', isJson: false }
  }
  if (s[0] === '{' || s[0] === '[') {
    try {
      const obj = JSON.parse(s)
      const root = Array.isArray(obj) ? obj[0] : obj
      if (root && typeof root === 'object') {
        return {
          description: pick(root, JSON_KEYS.description) || '',
          appleMobileWebAppTitle: pick(root, JSON_KEYS.appleMobileWebAppTitle),
          applicationName: pick(root, JSON_KEYS.applicationName),
          msapplicationTileColor: pick(root, JSON_KEYS.msapplicationTileColor),
          themeColor: pick(root, JSON_KEYS.themeColor),
          isJson: true,
        }
      }
    } catch {
      // не JSON — трактуем как plain description
    }
  }
  return { description: s, isJson: false }
}
